import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import classnames from 'classnames';

import { CartItemCardShimmer } from './CartItemCardShimmer';
import { CartGrid } from '../CartGrid';
import { CartTotalsShimmer } from '../CartSidebar/CartTotalsShimmer';

import dibsCss from 'dibs-css';

type Props = {
    isMobile: boolean;
};

export const CartPageShimmer: FC<Props> = ({ isMobile }) => {
    return (
        <>
            <div
                className={classnames(dibsCss.myLarge, dibsCss.mbMedium, dibsCss.mtLarge, {
                    [dibsCss.sassyFontHeaderMedium]: isMobile,
                    [dibsCss.sassyFontHeaderLarge]: !isMobile,
                })}
            >
                <FormattedMessage
                    id="cart.page.shoppingCart"
                    defaultMessage="Shopping Cart {hasItems, select, true {({numOfItems})} other {}}"
                    values={{
                        numOfItems: 0,
                        hasItems: false,
                    }}
                />
            </div>
            <div className={dibsCss.mbXxlarge}>
                <CartGrid
                    left={
                        <>
                            <CartItemCardShimmer />
                            <CartItemCardShimmer />
                            <CartItemCardShimmer />
                        </>
                    }
                    right={isMobile ? null : <CartTotalsShimmer />}
                />
            </div>
        </>
    );
};
